module.exports = __webpack_public_path__ + "img/404.bbe5f59a.svg";